import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosClient from '@/services/axios';

export const fetchPlaceOrderDetails = createAsyncThunk(
  'placeOrder/fetchPlaceOrderDetails',
  async ({ orderID, phone }, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(`/api/order/details`, {
        order_id: orderID,
        phone,
      });
      return response?.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export const defaultTemp = () => {};
